import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue')
const Pagamento = () => import('./Pagamento.vue')

export default {
    path: 'pagamentos',
    name: 'AppSebrae_Consultorias_Uabs_Pagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('APPSE-UABS-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'AppSebrae_Consultorias_Uabs_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('APPSE-UABS-PAG-01')) {
                    next()
                }
            }
        }
    ]
}
